module.exports = __webpack_public_path__ + "img/pinduoduo_7.49941143.png";